import {
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	SelectProps,
	SxProps,
	Theme,
	SelectChangeEvent,
} from "@mui/material";
import React from "react";

const style: { [key: string]: SxProps<Theme> } = {
	formControl :{
		margin: "8px 0px"
	},
	input: {
		background: "#fff",
		borderRadius: "0px",
		minHeight: "32px",
	},
};

interface CustomSelectProps extends SelectProps {
	onChange?: (
		event: SelectChangeEvent<unknown>,
		child: React.ReactNode
	) => void;
	value: string | number;
	error?: boolean;
	errorText?: string;
	touched?: boolean;
	name: string;
	label?: string;
	items: { key: string | number; value: string | number; label?: string }[];
	sx?: SxProps<Theme>;
	sxFC?: SxProps<Theme>;
	Icon?: (props: any) => JSX.Element | null;
	datatestId?: string;
}

function CustomSelect(props: CustomSelectProps) {
	const {
		value,
		error,
		touched,
		name,
		label,
		onChange,
		items,
		errorText,
		sxFC,
		Icon,
		datatestId,
		sx,
		...other
	} = props;

	const mergedSelectStyle = { ...style.input, ...(sx || {}) };
	const mergedFCStyle = { ...style.formControl, ...(sxFC || {}) };

	return (
		<FormControl
			fullWidth
			size="small"
			error={!!error && !!touched}
			sx={mergedFCStyle}
		>
			<InputLabel>{label}</InputLabel>
			<Select
				data-testid={datatestId}
				sx={mergedSelectStyle}
				{...other}
				name={name}
				value={value ?? ""}
				label={label}
				onChange={onChange}
				error={!!error && !!touched}
			>
				{items?.map(
					(item: {
						key: string | number;
						value: string | number;
						label?: string;
					}) => (
						<MenuItem
							data-testid={`test-${item.key}`}
							key={item.key}
							value={item.value}
							aria-label={"" + item.value}
						>
							{Icon && (
								<>
									<Icon item={item.value} />
									{"\u00A0\u00A0"}
								</>
							)}

							{item.label ? item.label : item.value}
						</MenuItem>
					)
				)}
			</Select>
			{!!error && touched && <FormHelperText>{errorText}</FormHelperText>}
		</FormControl>
	);
}

export default CustomSelect;
